import { db, FieldValue } from "helpers/firebase";
const serverTimestamp = FieldValue.serverTimestamp;

export const getMessageGroupsRef = (uid) => {

  if (!uid) {
    return Promise.reject(Error("uid is required"));
  }

  const groupRef = db
    .collection(`/message_groups`)
    .where("member_ids", "array-contains", uid);

  return groupRef;
}

export const createMessageGroup = (selectedUsers) => {
  if (!selectedUsers) {
    return Promise.reject(Error("selected users is required"));
  }

  const newMessageGroup = db.collection('/message_groups').doc();

  return newMessageGroup.set({
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
    members: selectedUsers,
    member_ids: selectedUsers.map(user => user.uid)
  })
}


export const getMessagesRef = (message_group_id, last_message = null) => {

  if (!message_group_id) {
    return Promise.reject(Error("message group id is required"));
  }

  const messagesRef = db
    .collection(`/message_groups/${message_group_id}/messages`)
    .orderBy("created_at", "desc");

  return last_message
    ? messagesRef.startAfter(last_message)
    : messagesRef;
}

// CRUD
export const createMessage = (message_group_id, params) => {
  return db
    .collection(`/message_groups/${message_group_id}/messages`)
    .doc()
    .set({
      ...params,
      created_at: serverTimestamp(),
      updated_at: serverTimestamp()
    })
    .then(() => updateLastMessage(message_group_id, params.content));
}

export const updateMessage = (message_group_id, message_id, params) => {
  return db
    .doc(`/message_groups/${message_group_id}/messages/${message_id}`)
    .update({
      ...params,
      updated_at: serverTimestamp()
    })
    .then(() => updateLastMessage(message_group_id, params.content));
}

export const updateLastMessage = (message_group_id, last_message) => {
  return db
    .doc(`/message_groups/${message_group_id}`)
    .update({
      last_message,
      updated_at: serverTimestamp()
    })
}

export const deleteMessage = (message_group_id, message_id) => {
  return db
    .doc(`/message_groups/${message_group_id}/messages/${message_id}`)
    .delete();
}